/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_steps/GiftCardStep.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Wed Apr 16 2025
 */

import React, { useContext} from 'react';
import {FormContext} from "@proxy/_contexts";
import {
  CardValue,
  RecipientDetailsDigital,
  RecipientDetailsPhysical,
  DeliveryDate,
  Footer
} from "../_sections";

export default function GiftCardStep({
  togglePreview
}) {

  const { settings, fulfillmentType, currentStep, bulkOrder }  = useContext(FormContext);

  return (
    <div className={currentStep === "gift_card" ? "gc__step gc__step_active" : "gc__step gc__step_inactive"}>
      {(settings?.global?.appearance?.form_theme !== "product_template" || bulkOrder) && (
        <CardValue />
      )}
      {(fulfillmentType === "physical") ?
        <RecipientDetailsPhysical />
      :
        <RecipientDetailsDigital />
      }
      <DeliveryDate />
      {settings?.global?.appearance?.form_theme === "classic" && (
        <Footer togglePreview={togglePreview} />
      )}
    </div>
  );
};
